import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Scroll from 'react-scroll';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faCalendarMinus, faCalendarPlus, faDumbbell, faCalendar, faGauge, faSearch, faEye, faPencil, faTrashCan, faPlus, faArrowRight, faTable, faArrowUpRightFromSquare, faFilter, faRefresh, faCalendarCheck, faUsers } from '@fortawesome/free-solid-svg-icons';
import { useRecoilState } from 'recoil';
import { DateTime } from "luxon";

import { PAGE_SIZE_OPTIONS } from "../../../../Constants/FieldOptions";


function UserSessionVideoSectionExerciseListDesktop(props) {
    const { uid, sid, vsid, exercises, onSelectExerciseForDeletion } = props;
    return (
        <table class="table is-fullwidth">
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Type</th>
                    <th>Duration (Min)</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {exercises && <>
                    {exercises.map((object, i) => <ExerciseRow obj={object} key={i} eIndex={i} uid={uid} sid={sid} vsid={vsid} onSelectExerciseForDeletion={onSelectExerciseForDeletion} />)}
                </>}
            </tbody>
        </table>
    );
}


function ExerciseRow(props) {
    const { obj, uid, sid, vsid, eIndex, onSelectExerciseForDeletion } = props;
    if (obj === undefined) {
        return null;
    }
    const { name, duration, previewDescription, previewUrl, type, videoUrl } = obj;
    console.log(name, duration, previewDescription, previewUrl, type, videoUrl);
    return (
        <tr>
            <th>{name}</th>
            <td>{type}</td>
            <td>{duration}</td>
            <td class="is-pulled-right">
                <Link to={`/user/${uid}/session/${sid}/video-section/${vsid}/exercise/${eIndex}`} class="button is-small is-success jb-modal" data-target="sample-modal" type="button">
                    <FontAwesomeIcon className="mdi" icon={faEye} />&nbsp;View
                </Link>
                {/*
                &nbsp;&nbsp;&nbsp;
                <Link to={`/user/${uid}/session/${sid}/video-section/${vsid}/exercise/${eIndex}/edit`} class="button is-small is-warning jb-modal" data-target="sample-modal" type="button">
                    <FontAwesomeIcon className="mdi" icon={faPencil} />&nbsp;Edit
                </Link>
                &nbsp;&nbsp;&nbsp;
                <button onClick={(e, ses) => onSelectExerciseForDeletion(e, obj)} class="button is-small is-danger"><FontAwesomeIcon className="mdi" icon={faTrash} />&nbsp;Delete</button>
                */}
            </td>
        </tr>
    );
}

export default UserSessionVideoSectionExerciseListDesktop;
